import { alertsConstants } from "../../constants/client";

const initialState = {};

export default function alerts(state = initialState, action) {
  let oldstate = state;
  let currentstate = false;

  switch (action.type) {

    case alertsConstants.ALERT_LISTING_REQUEST:
      currentstate = {
        paginationOptions: null,
        list: null,
        configLoading:true
      };
      break;
    case alertsConstants.ALERT_LISTING_SUCCESS:
      currentstate = {
        list: action.payload.list,
        paginationOptions: action.payload.paginationOptions,
        configLoading:false
      };
      break;


    case alertsConstants.ALERT_SAVE_REQUEST:
      currentstate = {
        update_required:false
      };
      break;
    case alertsConstants.ALERT_SAVE_SUCCESS:
      currentstate = {
        update_required:true
      };
      break;


    case alertsConstants.ALERT_DELETE_REQUEST:
      currentstate = {
        update_required:false
      };
      break;
    case alertsConstants.ALERT_DELETE_SUCCESS:
      currentstate = {
        update_required:true
      };
      break;


    default:
      break;
  }

  if (!!currentstate) {
    return { ...oldstate, ...currentstate };
  } else {
    return oldstate;
  }
}
